export default __webpack_public_path__ + "static/inbox-feature-two-05fab692c4e3de05c854da88ca9bd1d3.png";